import {
    DELETE_CONTRACTOR_SUCCESS,
    DELETE_CONTRACTOR_FAILURE,
} from "../constants/MyM";
  
const initStat = { data: [], error: false, errorData: "", isLoading: true };
  
export default (state = initStat, action) => {
    switch (action.type) {
      case DELETE_CONTRACTOR_SUCCESS:
        return {
          ...state,
          data: action.payload,
          isLoading: false,
        };
      case DELETE_CONTRACTOR_FAILURE:
        return {
          ...state,
          isLoading: false,
          errorData: action.payload,
          error: true,
        };
      default:
        return { ...state };
    }
};
  